import React from 'react';
import { useLocation } from "react-router-dom";

import GetAllBlogPosts from '../../../../hooks/getAllBlogPosts';
import BlogCard from "../BlogCard/BlogCard";
import useIsMobile from '../../../../hooks/useIsMobile';

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper";
import SwiperCore, { Navigation } from 'swiper';

import './BlogCardSwiper.css';

function BlogCardSwiper() {

    const { state } = useLocation();
    let { all_posts } = GetAllBlogPosts(state); 
    const isMobile = useIsMobile(675);
    // all_posts.reverse();

    return (
        <div className="blog-card-swiper-container">
            <Swiper
                key={isMobile ? 'mobile' : 'desktop'} // forces re-render of swiper component if becomes mobile, otherwise bullets might not update
                slidesPerView={1}
                slidesPerGroup={1}
                navigation={true}
                spaceBetween={10}
                pagination={{
                ...(isMobile && {
                    dynamicBullets: true,
                    dynamicMainBullets: 5,
                }), // limit bullets on mobile, otherwise don't 
                clickable: true,
                renderBullet: function(index, className) {
                    return '<span class="' + className + '"><img class="pagination-bullet" alt=""/></span>';
                }
                }}
                breakpoints={{
                    590: {
                        slidesPerView: 2,
                        slidesPerGroup: 2, // move along by 2 slides when arrow clicked
                        spaceBetween: 10,
                    },
                    675: {
                        slidesPerView: 2,
                        slidesPerGroup: 2,
                        spaceBetween: 10,
                    },
                    875: {
                        slidesPerView: 3,
                        slidesPerGroup: 3,
                        spaceBetween: 20,
                    },
                    1040: {
                        slidesPerView: 3,
                        slidesPerGroup: 3,
                        spaceBetween: 20,
                    },
                    1230: {
                        slidesPerView: 3.8,
                        slidesPerGroup: 3,
                        spaceBetween: 20,
                    },
                    1900: {
                        slidesPerView: 5,
                        slidesPerGroup: 5,
                        spaceBetween: 20,
                    },
                }}
                modules={[Navigation, Pagination]}
                className="blogCardSwiper"
            >
                {all_posts.map((post, index) => 
                    <SwiperSlide key={index}>
                        <BlogCard 
                            blogSlug={post.urlSlug}
                            blogTitle={post.title}
                            blogDate={post.date}
                            imageAltText={post.altText}
                        />
                    </SwiperSlide>
                )}
              </Swiper>
        </div>  
    )
}

export default BlogCardSwiper;